import { useFlag } from '@calendly/feature-check-react'

import { APP_SHELL_FLAG_KEY } from './constants'
import { useProductRefreshPreviewContext } from './productRefreshPreviewContext'

/**
 * Gates the new product refresh app shell layout.
 * True when `ap_rebrand_app_shell_ia` and the preview toggle are both on (`override === true`).
 */
export function useProductRefreshAppShell(): boolean {
  const { override } = useProductRefreshPreviewContext()
  const base = useFlag(APP_SHELL_FLAG_KEY, false)
  return override === true && base
}
